<template>
    <div class="upload_cls">
        <el-upload
                v-show="uploadflag"
                class="upload-demo"
                action=""
                :before-upload="beforeUpload"
                multiple
                :limit="limit">
            <el-button class="h-btn h-bBtn h-bgwhite">上传头像</el-button>
        </el-upload>
        <!--<ul class="el-upload-list el-upload-list&#45;&#45;text">
            <li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                <a class="el-upload-list__item-name" v-down="o.id"><i
                        class="el-icon-document"></i>{{o.name}}
                </a>    <label class="el-upload-list__item-status-label" v-if="showTime">
                {{o.cdate}}
            </label>
                <i @click="delfile(o)" v-show="delflag" class="el-icon-close"></i>
            </li>
        </ul>-->
    </div>

</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    export default {
        props:{
            refid:null,
            reftype:null,
            limit:{
                type: Number,
                default: 0
            },
            tips:'',
            //是否可以上传
            uploadflag:{
                type: Boolean,
                default: false
            },
            //是否可以删除
            delflag:{
                type: Boolean,
                default: false
            },
            showtime:{
                type:Boolean,
                default:true,
            }
        },
        computed: {
            reftypeVal: function () {
                return this.reftype;
            },
            refidVal:function(){
                return this.refid;
            },
            showTime:function () {
                return this.showtime;
            }
        },
        watch: {
            refid(val, newval) {
                this.fileList = [];
                this.loadFilelist(val)
            }
        },
        data() {
            return {
                fileList: []
            };
        },
        created() {
        },
        methods: {
            beforeUpload(file){
                uploaddown.uploadTX(file, {refid: this._user.usercode, reftype: this.reftypeVal, flag: this.limit}).then(rd => {
                })
            }
        },

    }
</script>
<style>
    .upload_cls .el-upload-list__item:first-child {
        margin-top: 0px;
    }
    .el-icon-close{
        display: block;
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
        width: auto!important;
        margin-top: 0px!important;
        right: 25px!important;
    }
    .el-upload-list__item .el-icon-close {
        display: block;
    }
    .el-upload-list__item.is-success:active .el-icon-close-tip, .el-upload-list__item.is-success:focus .el-upload-list__item-status-label, .el-upload-list__item.is-success:hover .el-upload-list__item-status-label, .el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip {
        display: block!important;
    }
</style>
